

export const roomType = {
  communal: "Rooms are communal",
  private: "Rooms are private",
} as const;

export const gendersServed = {
  women_only: "We only shelter women",
  men_only: "We only shelter men",
  men_and_women: "We shelter men and women",
} as const;

export const urbanRuralClassification = {
  rural: "Rural location",
  urban: "Urban location",
} as const;

export const disabilityAccessible = {
  true: "Accessible to people who are disabled",
  false: "Not accessible to people who are disabled",
} as const;

export const locationType = {
  rural: "Rural location",
  smallTown: "Small city or town location",
  suburban: "Suburban location",
  largeCity: "Large city location",
} as const;

export type AgencyWithLocation = Agency & {
  profile: {
    location: google.maps.LatLngLiteral;
  };
};
    
type AgencyProfile = {
    private: boolean;
    location: {
      lat: number;
      lng: number;
    };
    contact: {
      phone: string;
      email: string;
    };
    county: string;
    website: string;
    gendersServed: keyof typeof gendersServed;
    roomType: keyof typeof roomType;
    disabilityAccessible: boolean;
    lgbtqFriendly: boolean;
    publicTransportation: boolean;
    locationType: keyof typeof locationType;
    memberSince: string;
    defaultGroupId: string;
    adaCompliant: boolean;
    urbanRuralClassification: keyof typeof urbanRuralClassification;
    referral: string;
};
  
export type Agency = {
    agencyId: string;
    details: {
      referral: {
        phone: string;
        email: string;
      };
      city: string;
      admin: {
        email: string;
        name: string;
      };
      displayName: string;
      fee: number;
      name: string;
      visible: boolean;
      state: string;
      notifications: {
        phone: string;
        sms: string;
        email: string;
        voice: string;
      }[];
      email: string;
    };
    name: string;
    wizardStatus: "welcome" | "notifications" | "contacts" | "thankyou" | null;
    createdAt: string;
    groupInfo: {
      groupId: string;
      agencyGroupMemberId: string;
      canAnswerRequest: boolean;
      canReceiveRequest: boolean;
      canSendRequest: boolean;
      regionalSupporter: boolean;
    }[];
    groupId: string[];
    survivorPopulation: string[] | null;
    namespace: string[];
    profile: { [K in keyof AgencyProfile]: AgencyProfile[K] | "__private__" };
    active: boolean;
    modifiedAt: string;
};

export type AgencyResponse = {
    availability: string | null;
    agencyDetails: Agency;
    modifiedAt: string;
};

export type AgencyResponses = {
    possible: AgencyResponse[];
    no: AgencyResponse[];
    null: AgencyResponse[];
};

export type UpdateAgency = Partial<
  Omit<Agency, "details"> & { details: Partial<Agency["details"]>; form: any }
>;